// External libraries
import { Component } from "react";

// Preact Signals
import { effect } from "@preact/signals-react";

// Kendo React components
import { Label } from "@progress/kendo-react-labels";

// Utilities
import { Invisible } from "../../Utilities/EntryUtils";

export class LabelField extends Component {
  constructor({ field, value, eventIndex, galleryParentName }) {
    super();
    const { fieldName, properties } = field;
    this.state = {
      value: value || field.value,
      invisible: false,
    };
    this.fieldName = typeof eventIndex === "number" ? `${fieldName}_${eventIndex}` : fieldName;
    this.name = fieldName;
    this.fontSize = properties?.fontSize || "12";
    this.fontWeight = properties?.fontWeight || "normal";
    this.label = properties?.Label;
    this.galleryParentName = galleryParentName;
    this.parameterValues = properties?.ParameterValues;
    this.visibilityRules = properties?.VisibilityRules;
    this.style = {
      fontSize: `${this.fontSize}px`,
      fontWeight: this.fontWeight,
      marginTop: "auto",
      marginBottom: "auto",
    };
    this.disposeDependencyEffect = () => {};
  }

  shouldComponentUpdate(_, nextState) {
    return this.state.value !== nextState.value || this.state.invisible !== nextState.invisible;
  }

  componentDidMount() {
    if (this.visibilityRules) this.handleDependencyEffect();
  }

  componentWillUnmount() {
    this.disposeDependencyEffect();
  }

  handleDependencyEffect() {
    this.disposeDependencyEffect = effect(() => {
      this.setState({
        invisible: Invisible({
          VisibilityRules: this.visibilityRules,
          parameterValues: this.parameterValues,
          eventIndex: this.eventIndex,
          galleryName: this.galleryParentName,
        }),
      });
    });
  }

  render() {
    if (this.state.invisible) return;
    return (
      <Label
        data-testid={this.fieldName}
        style={this.style}
        id={this.fieldName}
        name={this.fieldName}
      >
        {this.label || this.state.value || this.name}
      </Label>
    );
  }
}
